// frozen_string_literal: true

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "multifactorContainer",
    "activationCheckbox",
    "innerSettings",
    "smsOption",
    "passwordOption",
    "smsSection",
    "passwordSection",
    "smsRadio",
    "passwordRadio",
    "countryCodeSection",
    "passwordContent",
    "adminContactCheckbox",
    "countryCode"
  ]

  declare readonly multifactorContainerTarget: HTMLElement
  declare readonly activationCheckboxTarget: HTMLInputElement
  declare readonly innerSettingsTarget: HTMLElement
  declare readonly smsOptionTarget: HTMLElement
  declare readonly passwordOptionTarget: HTMLElement
  declare readonly smsSectionTarget: HTMLElement
  declare readonly passwordSectionTarget: HTMLElement
  declare readonly smsRadioTarget: HTMLInputElement
  declare readonly passwordRadioTarget: HTMLInputElement
  declare readonly countryCodeSectionTarget: HTMLElement
  declare readonly passwordContentTarget: HTMLElement
  declare readonly adminContactCheckboxTarget: HTMLInputElement
  declare readonly countryCodeTarget: HTMLSelectElement

  connect() {
    this.updateVisibility()
  }

  toggleSetting() {
    const isEnabled = this.activationCheckboxTarget.checked

    this.updateVisibility()
  }

  onAuthenticationTypeChange() {
    if (this.activationCheckboxTarget.checked) {
      this.updateConfigurationSections()
    }
  }

  private updateVisibility() {
    if (this.activationCheckboxTarget.checked) {
      this.innerSettingsTarget.classList.add('active')
      this.innerSettingsTarget.style.display = 'block'
      this.multifactorContainerTarget.classList.add('active_setting')
      this.showRadioOptions()
      this.updateConfigurationSections()
    } else {
      this.innerSettingsTarget.classList.remove('active')
      this.multifactorContainerTarget.classList.remove('active_setting')
      this.innerSettingsTarget.style.display = 'none'
      this.hideAllSections()
    }
  }

  private showRadioOptions() {
    this.smsOptionTarget.style.display = 'block'
    this.passwordOptionTarget.style.display = 'block'
  }

  private updateConfigurationSections() {
    const isSmsSelected = this.smsRadioTarget.checked
    const isPasswordSelected = this.passwordRadioTarget.checked

    if (isSmsSelected) {
      this.smsSectionTarget.classList.remove('hide')
      this.smsSectionTarget.style.display = 'block'
    } else {
      this.smsSectionTarget.classList.add('hide')
      this.smsSectionTarget.style.display = 'none'
    }

    if (isPasswordSelected) {
      this.passwordSectionTarget.classList.remove('hide')
      this.passwordSectionTarget.style.display = 'block'
    } else {
      this.passwordSectionTarget.classList.add('hide')
      this.passwordSectionTarget.style.display = 'none'
    }
  }

  private hideAllSections() {
    this.smsOptionTarget.style.display = 'none'
    this.passwordOptionTarget.style.display = 'none'
    this.smsSectionTarget.classList.add('hide')
    this.passwordSectionTarget.classList.add('hide')
  }
}
